import { ChipProps, Stack } from '@mui/material';
import { FilterParams } from '@synergy/models';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { FilterChip } from '../../../../components/filter';
import { currencySelector } from '../../../../store/configuration-selectors';
import { useAppSelector } from '../../../../../store/store';

export const MinMaxPriceFilterChip = (props: ChipProps): ReactElement | null => {
    const [searchParams, setSearchParams] = useSearchParams();
    const minPrice = searchParams.get(FilterParams.MinPrice);
    const maxPrice = searchParams.get(FilterParams.MaxPrice);
    const currency = useAppSelector(currencySelector);

    if (!minPrice && !maxPrice) return null;

    const handleChipDelete = (): void => {
        searchParams.delete(FilterParams.MinPrice);
        searchParams.delete(FilterParams.MaxPrice);
        setSearchParams(searchParams);
    };

    return (
        <FilterChip
            label={
                <Stack direction="row" gap={0.5}>
                    <strong>
                        <FormattedMessage id="app.filter.price" />
                    </strong>
                    <span>
                        <FormattedNumber
                            value={minPrice ? +minPrice : 0}
                            currency={currency}
                            style="currency"
                            maximumFractionDigits={0}
                        />
                    </span>
                    {maxPrice && (
                        <span>
                            <FormattedMessage id="app.filter.price.to" />{' '}
                            <FormattedNumber
                                value={+maxPrice}
                                currency={currency}
                                style="currency"
                                maximumFractionDigits={0}
                            />
                        </span>
                    )}
                </Stack>
            }
            onChipDelete={handleChipDelete}
            {...props}
        />
    );
};
